<template>
    <div class="sidebar">
        <nav class="sidebar-nav">
            <ul class="nav">
                <li class="nav-item">
                    <router-link :to="'/'" class="nav-link">
                        <i class="icon-speedometer"></i>
                        Dashboard
                    </router-link>
                </li>
                <!-- <li class="nav-title">
                    Cadastros
                </li>-->
                <router-link
                    tag="li"
                    class="nav-item nav-dropdown"
                    :to="{ path: '/cadastros/usuarios'}"
                    disabled
                    v-dw-authorized="{ roles: ['A', 'D'] }"
                >
                    <div class="nav-link nav-dropdown-toggle" @click="handleClick">
                        <i class="fa fa-user"></i>
                        Usuários
                    </div>
                    <ul class="nav-dropdown-items">
                        <li class="nav-item">
                            <router-link :to="'/cadastros/usuarios/novo'" class="nav-link" exact>
                                <i class="icon-plus"></i>
                                Criar
                            </router-link>
                        </li>

                        <li class="nav-item">
                            <router-link :to="'/cadastros/usuarios'" class="nav-link" exact>
                                <i class="icon-list"></i>
                                Listar
                            </router-link>
                        </li>
                    </ul>
                </router-link>
                <router-link
                    tag="li"
                    class="nav-item nav-dropdown"
                    :to="{ path: '/cadastros/usuarios'}"
                    disabled
                    v-dw-authorized="{ roles: ['A', 'D'] }"
                >
                    <div class="nav-link nav-dropdown-toggle" @click="handleClick">
                        <i class="icon-people"></i>
                        Clientes
                    </div>
                    <ul class="nav-dropdown-items">
                        <li class="nav-item">
                            <router-link :to="'/cadastros/clientes/novo'" class="nav-link" exact>
                                <i class="icon-plus"></i>
                                Criar
                            </router-link>
                        </li>

                        <li class="nav-item">
                            <router-link :to="'/cadastros/clientes'" class="nav-link" exact>
                                <i class="icon-list"></i>
                                Listar
                            </router-link>
                        </li>
                    </ul>
                </router-link>
                <router-link
                    tag="li"
                    class="nav-item nav-dropdown"
                    :to="{ path: '/cadastros/clinicas'}"
                    disabled
                    v-dw-authorized="{ roles: ['A', 'D'] }"
                >
                    <div class="nav-link nav-dropdown-toggle" @click="handleClick">
                        <i class="fa fa-map-marked-alt"></i>
                        Rede Credenciada
                    </div>
                    <ul class="nav-dropdown-items">
                        <li class="nav-item">
                            <router-link :to="'/cadastros/clinicas/novo'" class="nav-link" exact>
                                <i class="icon-plus"></i>
                                Criar
                            </router-link>
                        </li>

                        <li class="nav-item">
                            <router-link :to="'/cadastros/clinicas'" class="nav-link" exact>
                                <i class="icon-list"></i>
                                Listar
                            </router-link>
                        </li>

                        <li class="nav-item">
                            <router-link
                                :to="'/cadastros/clinicas/importar'"
                                class="nav-link"
                                exact
                            >
                                <i class="fa fa-upload"></i>
                                Importar
                            </router-link>
                        </li>
                    </ul>
                </router-link>
                <router-link
                    tag="li"
                    class="nav-item nav-dropdown"
                    :to="{ path: '/cadastros/apolices'}"
                    disabled
                    v-dw-authorized="{ roles: ['A', 'D'] }"
                >
                    <div class="nav-link nav-dropdown-toggle" @click="handleClick">
                        <i class="fas fa-file-contract"></i>
                        Apólices
                    </div>
                    <ul class="nav-dropdown-items">
                        <li class="nav-item">
                            <router-link :to="'/cadastros/apolices'" class="nav-link" exact>
                                <i class="icon-list"></i>
                                Listar
                            </router-link>
                        </li>
                    </ul>
                </router-link>
                <router-link
                    tag="li"
                    class="nav-item nav-dropdown"
                    :to="{ path: '/cadastros/categorias'}"
                    disabled
                    v-dw-authorized="{ roles: ['T','A'] }"
                >
                    <div class="nav-link nav-dropdown-toggle" @click="handleClick">
                        <i class="icon-list"></i>
                        Categoria
                    </div>
                    <ul class="nav-dropdown-items">
                        <li class="nav-item">
                            <router-link :to="'/cadastros/categorias/novo'" class="nav-link" exact>
                                <i class="icon-plus"></i>
                                Criar
                            </router-link>
                        </li>

                        <li class="nav-item">
                            <router-link :to="'/cadastros/categorias'" class="nav-link" exact>
                                <i class="icon-list"></i>
                                Listar
                            </router-link>
                        </li>
                    </ul>
                </router-link>

                <router-link
                    tag="li"
                    class="nav-item nav-dropdown"
                    :to="{ path: '/cadastros/post'}"
                    disabled
                    v-dw-authorized="{ roles: [ 'T','A'] }"
                >
                    <div class="nav-link nav-dropdown-toggle" @click="handleClick">
                        <i class="fas fa-paste"></i>
                        Post
                    </div>
                    <ul class="nav-dropdown-items">
                        <li class="nav-item">
                            <router-link :to="'/cadastros/post/novo'" class="nav-link" exact>
                                <i class="icon-plus"></i>
                                Criar
                            </router-link>
                        </li>

                        <li class="nav-item">
                            <router-link :to="'/cadastros/post'" class="nav-link" exact>
                                <i class="icon-list"></i>
                                Listar
                            </router-link>
                        </li>
                    </ul>
                </router-link>

                <router-link
                    tag="li"
                    class="nav-item nav-dropdown"
                    :to="{ path: '/cadastros/integradoras'}"
                    disabled
                    v-dw-authorized="{ roles: ['A', 'D'] }"
                >
                    <div class="nav-link nav-dropdown-toggle" @click="handleClick">
                        <i class="fas fa-satellite-dish"></i>
                        Integradoras
                    </div>
                    <ul class="nav-dropdown-items">
                        <li class="nav-item">
                            <router-link :to="'/cadastros/integradoras/novo'" class="nav-link" exact>
                                <i class="icon-plus"></i>
                                Criar
                            </router-link>
                        </li>

                        <li class="nav-item">
                            <router-link :to="'/cadastros/integradoras'" class="nav-link" exact>
                                <i class="icon-list"></i>
                                Listar
                            </router-link>
                        </li>
                    </ul>
                </router-link>

                <router-link
                    tag="li"
                    class="nav-item nav-dropdown"
                    :to="{ path: '/cadastros/paises'}"
                    disabled
                    v-dw-authorized="{ roles: ['A', 'D'] }"
                >
                    <div class="nav-link nav-dropdown-toggle" @click="handleClick">
                        <i class="fas fa-globe"></i>
                        Países
                    </div>
                    <ul class="nav-dropdown-items">
                        <li class="nav-item">
                            <router-link :to="'/cadastros/paises/novo'" class="nav-link" exact>
                                <i class="icon-plus"></i>
                                Criar
                            </router-link>
                        </li>

                        <li class="nav-item">
                            <router-link :to="'/cadastros/paises'" class="nav-link" exact>
                                <i class="icon-list"></i>
                                Listar
                            </router-link>
                        </li>
                    </ul>
                </router-link>

                <router-link
                    tag="li"
                    class="nav-item nav-dropdown"
                    :to="{ path: '/cadastros/operadoras'}"
                    disabled
                    v-dw-authorized="{ roles: ['A', 'D'] }"
                >
                    <div class="nav-link nav-dropdown-toggle" @click="handleClick">
                        <i class="fas fa-satellite"></i>
                        Operadoras
                    </div>
                    <ul class="nav-dropdown-items">
                        <li class="nav-item">
                            <router-link :to="'/cadastros/operadoras/novo'" class="nav-link" exact>
                                <i class="icon-plus"></i>
                                Criar
                            </router-link>
                        </li>

                        <li class="nav-item">
                            <router-link :to="'/cadastros/operadoras'" class="nav-link" exact>
                                <i class="icon-list"></i>
                                Listar
                            </router-link>
                        </li>
                    </ul>
                </router-link>

                <router-link
                    tag="li"
                    class="nav-item nav-dropdown"
                    :to="{ path: '/cadastros/manuais-usuario'}"
                    disabled
                    v-dw-authorized="{ roles: ['A', 'D'] }"
                >
                    <div class="nav-link nav-dropdown-toggle" @click="handleClick">
                        <i class="fas fa-handshake"></i>
                        Manuais Usuário
                    </div>
                    <ul class="nav-dropdown-items">
                        <li class="nav-item">
                            <router-link :to="'/cadastros/manuais-usuario/novo'" class="nav-link" exact>
                                <i class="icon-plus"></i>
                                Criar
                            </router-link>
                        </li>

                        <li class="nav-item">
                            <router-link :to="'/cadastros/manuais-usuario'" class="nav-link" exact>
                                <i class="icon-list"></i>
                                Listar
                            </router-link>
                        </li>
                    </ul>
                </router-link>

                <router-link
                    tag="li"
                    class="nav-item nav-dropdown"
                    :to="{ path: '/cadastros/central-atendimento'}"
                    disabled
                    v-dw-authorized="{ roles: ['A', 'D'] }"
                >
                    <div class="nav-link nav-dropdown-toggle" @click="handleClick">
                        <i class="fas fa-phone"></i>
                        Central Atendimento
                    </div>
                    <ul class="nav-dropdown-items">
                        <li class="nav-item">
                            <router-link :to="'/cadastros/central-atendimento/novo'" class="nav-link" exact>
                                <i class="icon-plus"></i>
                                Criar
                            </router-link>
                        </li>

                        <li class="nav-item">
                            <router-link :to="'/cadastros/central-atendimento'" class="nav-link" exact>
                                <i class="icon-list"></i>
                                Listar
                            </router-link>
                        </li>
                    </ul>
                </router-link>

                <router-link
                    tag="li"
                    class="nav-item nav-dropdown"
                    :to="{ path: '/cadastros/paginas'}"
                    disabled
                    v-dw-authorized="{ roles: ['A', 'D'] }"
                >
                    <div class="nav-link nav-dropdown-toggle" @click="handleClick">
                        <i class="fas fa-mobile-alt"></i>
                        Páginas
                    </div>
                    <ul class="nav-dropdown-items">
                        <li class="nav-item">
                            <router-link :to="'/cadastros/paginas/novo'" class="nav-link" exact>
                                <i class="icon-plus"></i>
                                Criar
                            </router-link>
                        </li>

                        <li class="nav-item">
                            <router-link :to="'/cadastros/paginas'" class="nav-link" exact>
                                <i class="icon-list"></i>
                                Listar
                            </router-link>
                        </li>
                    </ul>
                </router-link>

                <router-link
                    tag="li"
                    class="nav-item nav-dropdown"
                    :to="{ path: '/cadastros/menus'}"
                    disabled
                    v-dw-authorized="{ roles: ['A', 'D'] }"
                >
                    <div class="nav-link nav-dropdown-toggle" @click="handleClick">
                        <i class="fas fa-list"></i>
                        Menus
                    </div>
                    <ul class="nav-dropdown-items">
                        <li class="nav-item">
                            <router-link :to="'/cadastros/menus/novo'" class="nav-link" exact>
                                <i class="icon-plus"></i>
                                Criar
                            </router-link>
                        </li>

                        <li class="nav-item">
                            <router-link :to="'/cadastros/menus'" class="nav-link" exact>
                                <i class="icon-list"></i>
                                Listar
                            </router-link>
                        </li>
                    </ul>
                </router-link>

                <router-link
                    tag="li"
                    class="nav-item nav-dropdown"
                    :to="{ path: '/cadastros/cupons-desconto'}"
                    disabled
                    v-dw-authorized="{ roles: ['A', 'D'] }"
                >
                    <div class="nav-link nav-dropdown-toggle" @click="handleClick">
                        <i class="fas fa-tag"></i>
                        Cupons Desconto
                    </div>
                    <ul class="nav-dropdown-items">
                        <li class="nav-item">
                            <router-link :to="'/cadastros/cupons-desconto/novo'" class="nav-link" exact>
                                <i class="icon-plus"></i>
                                Criar
                            </router-link>
                        </li>

                        <li class="nav-item">
                            <router-link :to="'/cadastros/cupons-desconto'" class="nav-link" exact>
                                <i class="icon-list"></i>
                                Listar
                            </router-link>
                        </li>

                        <li class="nav-item">
                            <router-link
                                :to="'/cadastros/cupons-desconto/importar'"
                                class="nav-link"
                                exact
                            >
                                <i class="fa fa-upload"></i>
                                Importar
                            </router-link>
                        </li>
                    </ul>
                </router-link>
            </ul>
        </nav>
    </div>
</template>
<script>
import Facade from "../facade/facade";

const facade = new Facade();
export default {
    name: "sidebar",
    methods: {
        handleClick(e) {
            e.preventDefault();
            e.target.parentElement.classList.toggle("open");
        }
    }
};
</script>

<style lang="css">
.nav-link {
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// Sidebar.vue?5cd4abe0